import { useEffect, useState } from "react"
import { ChevronRight } from "lucide-react"
import { BlogCard } from "../blog-card"
import { Link } from "react-router-dom"
import { Button } from "../ui/button"
import { Badge } from "../ui/badge"

export default function HealthArticlesWidget() {
  const [blogs, setBlogs] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch("/wp-json/wp/v2/blogs?per_page=3&_embed")
      .then((res) => res.json())
      .then((data) => {
        setBlogs(data)
        setLoading(false)
      })
      .catch((err) => {
        console.error("Error fetching blogs:", err)
        setLoading(false)
      })
  }, [])

  return (
    <section className="py-12 bg-gray-100">
      <div className="container px-4 mx-auto">

        {/* Heading */}
        <div className="flex flex-col items-center mb-10 text-center">
          <Badge className="mb-2">Health Insights</Badge>
          <h2 className="mb-4 text-3xl font-bold md:text-4xl">
            Latest Health Articles
          </h2>
          <p className="max-w-2xl text-[#485260]">
            Stay informed with the latest health tips, medical advancements, and hospital news.
          </p>
        </div>

        {/* Blogs Grid */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {!loading &&
            blogs.map((blog) => {
             const thumbnail =
                blog?._embedded?.["wp:featuredmedia"]?.[0]?.media_details?.sizes?.thumbnail?.source_url;

              const medium =
                blog?._embedded?.["wp:featuredmedia"]?.[0]?.media_details?.sizes?.medium?.source_url;

              const mediumLarge =
                blog?._embedded?.["wp:featuredmedia"]?.[0]?.media_details?.sizes?.medium_large?.source_url;

              const large =
                blog?._embedded?.["wp:featuredmedia"]?.[0]?.media_details?.sizes?.large?.source_url;

              return (
                <BlogCard
                  key={blog.id}
                  title={blog.title.rendered}
                  excerpt={blog.excerpt.rendered.replace(/<[^>]+>/g, "")}
                  date={new Date(blog.date).toLocaleDateString("en-IN", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                  category={
                    blog?._embedded?.["wp:term"]?.[0]?.[0]?.name || "Health"
                  }
                  media={blog?._embedded?.["wp:featuredmedia"]?.[0]}
                  imageSmall={thumbnail}
                  imageMedium={medium}
                  imageLarge={large}
                  href={`/blogs/${blog.slug}`}
                />
              )
            })}
        </div>

        {/* View All */}
        <div className="flex flex-col sm:flex-row justify-center gap-3 mt-8 w-full sm:w-auto">
          <Button
            variant="outline"
            className="gap-2 border-primary text-primary hover:bg-primary hover:text-white h-10 px-6"
            asChild
          >
            <Link to="/blogs">
              View All Articles
              <ChevronRight className="w-4 h-4" />
            </Link>
          </Button>
          <Button className="gap-2 h-10 px-6" asChild>
            <Link to="/book-now">
              Book an Appointment
              
            </Link>
          </Button>
        </div>

      </div>
    </section>
  )
}
